/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ecommerce_Amazon_Tools_Monitor_Title7Inputs */

const en_svc_ecommerce_amazon_tools_monitor_title7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Monitor_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price and review monitoring`)
};

const ar_svc_ecommerce_amazon_tools_monitor_title7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Monitor_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مراقبة الأسعار والتقييمات`)
};

const bn_svc_ecommerce_amazon_tools_monitor_title7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Monitor_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দাম ও রিভিউ পর্যবেক্ষণ`)
};

const de_svc_ecommerce_amazon_tools_monitor_title7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Monitor_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preis- und Bewertungsmonitoring`)
};

const es_svc_ecommerce_amazon_tools_monitor_title7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Monitor_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monitorización de precios y reseñas`)
};

const fr_svc_ecommerce_amazon_tools_monitor_title7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Monitor_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivi des prix et des avis`)
};

const pt_svc_ecommerce_amazon_tools_monitor_title7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Monitor_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monitorização de preços e avaliações`)
};

const zh_svc_ecommerce_amazon_tools_monitor_title7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Monitor_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`价格与评价监控`)
};

const tr_svc_ecommerce_amazon_tools_monitor_title7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Monitor_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiyat ve yorum izleme`)
};

const ru_svc_ecommerce_amazon_tools_monitor_title7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Monitor_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мониторинг цен и отзывов`)
};

const pl_svc_ecommerce_amazon_tools_monitor_title7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Monitor_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monitoring cen i opinii`)
};

/**
* | output |
* | --- |
* | "Price and review monitoring" |
*
* @param {Svc_Ecommerce_Amazon_Tools_Monitor_Title7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ecommerce_amazon_tools_monitor_title7 = /** @type {((inputs?: Svc_Ecommerce_Amazon_Tools_Monitor_Title7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ecommerce_Amazon_Tools_Monitor_Title7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ecommerce_amazon_tools_monitor_title7(inputs)
	if (locale === "bn") return bn_svc_ecommerce_amazon_tools_monitor_title7(inputs)
	if (locale === "de") return de_svc_ecommerce_amazon_tools_monitor_title7(inputs)
	if (locale === "es") return es_svc_ecommerce_amazon_tools_monitor_title7(inputs)
	if (locale === "fr") return fr_svc_ecommerce_amazon_tools_monitor_title7(inputs)
	if (locale === "pt") return pt_svc_ecommerce_amazon_tools_monitor_title7(inputs)
	if (locale === "zh") return zh_svc_ecommerce_amazon_tools_monitor_title7(inputs)
	if (locale === "tr") return tr_svc_ecommerce_amazon_tools_monitor_title7(inputs)
	if (locale === "ru") return ru_svc_ecommerce_amazon_tools_monitor_title7(inputs)
	if (locale === "pl") return pl_svc_ecommerce_amazon_tools_monitor_title7(inputs)
	return en_svc_ecommerce_amazon_tools_monitor_title7(inputs)
});
export { svc_ecommerce_amazon_tools_monitor_title7 as "svc_ecommerce-amazon-tools_MONITOR_title" }